// react
import React, { useEffect } from "react";
import axios from 'axios'
// react-router-dom
import { Link, useLocation, useNavigate } from "react-router-dom";

// material
import Checkbox from "@mui/material/Checkbox";
// shared
import InputAuth from "@/shared/ui/InputAuth/InputAuth";
// hooks
import useLogin from "../../libs/hooks/useLogin";
// styles
import styles from "./Auth.module.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { saveModeActions } from "@/entities/saveMode";

import { useDispatch } from "react-redux";
import { useOpenProModal } from "@/Hooks/useOpenBillingModal";
const Auth = () => {

  const location = useLocation();
  const justRegistered = location.state?.justRegistered;
  const inviteKey = localStorage.getItem('invite')
  const dispatch = useDispatch();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [isRemember, setIsRemember] = React.useState(false);
  const { isLoggingIn, handleLogin, needsVerification } = useLogin();
  const navigate = useNavigate();

  const toggleRemember = () => {
    setIsRemember(!isRemember);
  };

  useEffect(() => {
    const savedUsername = localStorage.getItem('username')
    const savedPassword = localStorage.getItem('password')

    if (savedUsername && savedPassword) {
      setUsername(savedUsername)
      setPassword(savedPassword)
    }

    if (justRegistered) {
      toast.info("Please check your email and verify your account before logging in.", {
        autoClose: 5000,
      });
    }
  }, [justRegistered]);

  const inputFields = [
    {
      placeholder: "Enter email",
      type: "email",
      value: username,
      field: setUsername,
      autocomplete: "email",
      style: { backgroundColor: "#f1f1f1" },
    },
    {
      placeholder: "Password",
      type: "password",
      value: password,
      field: setPassword,
      autocomplete: "current-password",
      style: { border: "1px solid #dcdcdc" },
    },
  ];

  function postForm(action, data) {
    const f = document.createElement('form')
    f.method = 'POST'
    f.action = action

    for (const key in data) {
      const d = document.createElement('input')
      d.type = 'hidden'
      d.name = key
      d.value = data[key]
      f.appendChild(d)
    }
    document.body.appendChild(f)
    f.submit()
  }

  useEffect(() => {
    const url = `${import.meta.env.VITE_API_BASE_URL}/csrf/`
    axios.get(url, { withCredentials: true })
      .then((resp) => {

      })
  }, [])

  function getCookie(name) {
    let cookieValue = null
    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';')
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim()
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
          break
        }
      }
    }
    return cookieValue
  }

  function getCSRFToken() {
    return getCookie('csrftoken')
  }

  const getCallBackUrl = () => {

    //const callbackurl = 'http://localhost:10000/oauth/google/callback'
    const callbackurl = `${import.meta.env.VITE_BASE_URL_WEB}/oauth/google/callback`

    var url = new URL(callbackurl);

    if (inviteKey) {
      url.searchParams.set('invite', inviteKey);

    }

    return url.toString()
  }

  const handleGoogleLogin = () => {

    //const url = 'http://localhost:10000/_allauth/browser/v1/auth/provider/redirect'
    const url = `${import.meta.env.VITE_API_BASE_URL}/_allauth/browser/v1/auth/provider/redirect`

    postForm(url, {
      provider: 'google', //providerId,
      process: 'login',
      callback_url: getCallBackUrl(),
      csrfmiddlewaretoken: getCSRFToken()
    })
  }

  const openProModal = useOpenProModal();

  const handleOpenBillingPage = () => {
    if (inviteKey) {
      navigate('/register');
    } else {
      openProModal("Auth");
    }
  }

  //console.log('inviteKey', inviteKey)

  return (
    <div className={styles.root}>
      <h1>Welcome Back</h1>
      <div className={styles.auth}>
        <>
          <div onClick={handleGoogleLogin} className={styles.googleButton}>
            <img src="/img/googleIcon.svg" alt="googleImg" loading="lazy" />
            <p>Login with Google</p>
          </div>
          <p className={styles.textOr}>or</p>
          <form
            onSubmit={(e) => handleLogin(username, password, isRemember, e)}
            className={styles.form}
          >
            <div className={styles.boxInput}>
              {inputFields.map((input, index) => (
                <InputAuth
                  key={index}
                  placeholder={input.placeholder}
                  type={input.type}
                  onChange={input.field}
                  value={input.value}
                  autocomplete={input.autocomplete}
                  style={input.style}
                />
              ))}
            </div>
            <div className={styles.formButtons}>
              <div onClick={toggleRemember} className={styles.rememberButton}>
                <Checkbox
                  className={styles.checkbox}
                  checked={isRemember}
                  color="default"
                />
                <label>Remember Me</label>
              </div>
              <Link to="/reset" className={styles.forgotButton}>
                Forgot Password?
              </Link>
            </div>
            <button
              disabled={isLoggingIn}
              className={`${styles.formButtonLogin} ${isLoggingIn ? styles.isDisabled : ""
                }`}
            >
              Login
            </button>
          </form>

          {needsVerification && (
            <div className={styles.verificationMessage}>
              <p>Please verify your email address to continue</p>
              <button
                className={styles.formButtonLogin}
                onClick={() => navigate('/verify-email', { state: { email: username } })}
              >
                Go to Verification
              </button>
            </div>
          )}

          <div className={styles.containerCreated}>
            <p>
              Not registered yet?{" "}
              <span id="unlockProButton" onClick={handleOpenBillingPage}>
                {inviteKey ? "Register Now" : "Upgrade to Pro"}
              </span>
            </p>
          </div>
        </>
      </div>
    </div>
  );
};

export default Auth;

